import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    width: '100%',
    minWidth: '400px',
    maxWidth: '450px',
    padding: '55px 40px',
    borderRadius: '16px',
    border: `1px solid ${alpha(theme.palette.common.black, 0.12)}`,
  },
  header: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  title: {
    fontSize: '30px',
  },
  description: {},
  main: {
    marginTop: '35px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '25px',
  },
  user_input: {
    display: 'flex',
    width: '100%',
  },
  footer: {
    marginTop: '35px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '15px',
  },
}));
